<!-- 摄影师 -->
<template>
  <div class="photographer">
    <Top></Top>

    <div class="conMiddle">

      <div class="topCarousel" style="">
        <el-carousel style="width:100%; margin:0 auto" :interval="4000" type="card">
          <el-carousel-item v-for="(item, index) in lbtList" :key="index">
            <img id="lbtImg" @click='goActiveEdit(item.idOrLink)' ref="bannerHeight"
              :src="item.imagLink + '!yunshangzg'" />
            <h3 class="medium"></h3>
          </el-carousel-item>
        </el-carousel>
      </div>


      <el-container id="contain">
        <el-header style="">
          <h2>摄影名家+优秀摄影师</h2>
          <span style="color: #a3973c">FAMOUS PHOTOGRAPHER AND EXCELLEND PHOTOGRAPHER</span>
        </el-header>


        <!-- 摄影师盒子1 -->
        <!-- <div class="box1">
            <div class="item" @click="goPhotoerHome(item.idOrLink)" v-for="(item, index) in photoerList.slice(0, 5)"
              :key="index">
              <div class="img">
                <div class="eye" @click="goPhotoerHome(item.idOrLink)">
                  <img id="img" src="@/imgs/eyeS.svg" alt="">
                  <p>查看Ta的主页</p>
                </div>
                <div class="mask1"></div>
                <div class="mask2"></div>
                <div class="mask3"></div>
                <img
                  :src="item.headImage.substring(0, 4) !== 'http' ? 'https://www.yunshangzg.com/' + item.headImage : item.headImage"
                  alt="">
              </div>
              <h5>{{ item.realName }}</h5>
              <p v-for="it in item.specialties.split('；')" :key="it + Math.random()"> <span>·</span> {{ it }}</p>
            
            </div>
            </div> -->

        <!-- 摄影师盒子2 -->
        <!-- <div class="box2">
          <div class="item" @click="goPhotoerHome(item.idOrLink)" v-for="(item, index) in photoerList.slice(5)"
            :key="index">
            <div class="img">
              <img style="border-radius: 50%;"
                :src="item.headImage.substring(0, 4) !== 'http' ? 'https://www.yunshangzg.com/' + item.headImage : item.headImage"
                alt="">
            </div>
            <div class="text">
              <div class="name" style="font-weight: bold;">{{ item.realName }}</div>
              <p style=""> {{ item.field }}
              </p>
            </div>
          </div>
          </div> -->

        <!-- 优秀供稿人 -->
        <div class="box3">
          <!-- <el-header>
            <h2>优秀供稿人</h2>
            <span style="color: #a3973c">FAMOUS PHOTOGRAPHER AND EXCELLEND PHOTOGRAPHER</span>
            </el-header> -->


        </div>
        <div class="goodBox">
          <div class="item" @click="goPhotoerHome(item.idOrLink)" v-for="(item, index) in contributorList.slice(0, 10)"
            :key="index">
            <div class="img">
              <img :src="item.imagLink + '?x-oss-process=image/resize,h_300'" alt="">
            </div>
            <div class="bottom">
              <div class="img">
                <img style="border-radius: 50%;"
                  :src="item.headImage.substring(0, 4) !== 'http' ? 'https://www.yunshangzg.com/' + item.headImage : item.headImage"
                  alt="">
              </div>
              <div class="text">
                <div class="name">{{ item.realName }}</div>
                <!-- <p>作品数：2123 </p> -->
              </div>
            </div>
          </div>
        </div>

      </el-container>
    </div>


    <!-- 底部 -->
    <div>
      <div class="btns">
        <img src="../imgs/Rectangle 429.png" style="position: relative;width: 100%;" />
        <div class="describes">
          <h3 class="describe">成为供稿人</h3>
          <p class="describ">把你的作品变成钱</p>
          <el-button class="btn" @click='goC'>立即加入</el-button>
        </div>
        <div class="demand">
          <div class="contri-div">
            <div class="contri-img">
              <img class="imgW" :src="require('../imgs/authentication.png')" />


              <p class="demonstration">认证</p>
            </div>
            <div class="contri-img">
              <img class="imgW" :src="require('../imgs/upload.png')" />

              <p class="demonstration">上传作品</p>
            </div>
            <div class="contri-img">
              <img class="imgW" :src="require('../imgs/icon_examine.png')" />


              <p class="demonstration">审核</p>
            </div>
            <div class="contri-img">
              <img class="imgW" :src="require('../imgs/realization.png')" />

              <p class="demonstration">售卖变现</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 回到顶部 -->
    <el-backtop :visibility-height="300">
      <div class="inn">
        <img src="@/imgs/backtop.png" alt="">
      </div>
    </el-backtop>
    <service />
    <shopFloat />
    <Foot></Foot>
  </div>
</template>
<script>
import Pagination from "../components/pagination.vue";
import Foot from "../components/foot.vue";
import Top from "../components/top";
export default {
  components: { Top, Foot, Pagination },
  name: "photographer",
  data() {
    return {
      lbtList: [],//轮播图
      photoerList: [],//摄影师
      contributorList: [],//优秀供稿人
    };
  },
  created() {
    this.getLbt()

  },
  mounted() {

  },
  methods: {
    // 获取轮播图
    async getLbt() {
      const res = await this.$axios.get('/homeReception/findChart', { params: { commendType: 4, advertisementType: 1 } })
      this.lbtList = res.data
      // console.log( this.lbtList);
      this.getPhotoerList()
      this.getContributorList()
    },

    // 获取优秀摄影师
    async getPhotoerList() {
      const res = await this.$axios.get('/homeReception/photographerList', { params: { advertisementType: 7 } })
      this.photoerList = res.data
    },

    // 获取优秀供稿人
    async getContributorList() {
      const res = await this.$axios.get('/homeReception/photographerList', { params: { advertisementType: 8 } })
      this.contributorList = res.data
    },

    // 去摄影师主页
    goPhotoerHome(id) {
      this.$router.push({
        path: '/myWork',
        query: {
          userId: id,
        }
      })
    },


    // 点击活动征稿跳转详情页
    goActiveEdit(activeId) {
      console.log(activeId);
      // 传活动id过去
      this.$router.push({
        path: '/activeDetail',
        query: {
          id: activeId
        }
      })
    },

    // 成为供稿人按钮
    goC() {
      this.$router.push('/contributor')
    }

  },

};
</script>
<style lang="scss" scoped>
.conMiddle {
  width: 1600px;
  margin: 0 auto;
}

// 头部轮播

.topCarousel {
  width: 100%;
  margin-top: 50px;

  /deep/ .el-carousel__item--card.is-active {
    width: 850px;
    // transform: translateX(213.4px) !important;
  }


  /deep/ .el-carousel__button {
    display: block;
    width: 8px;
    height: 8px;
    background: #D9D9D9;
    border-radius: 50%;
    opacity: 0.7;
    border: 0 !important;
    border-radius: 50%;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: 0.3s;
  }

  /deep/ .el-carousel__indicator.is-active button {
    width: 24px;
    height: 8px;
    background: #DC3B3B;
    opacity: 1;
    border-radius: 8px;
  }

  /deep/ .el-carouse {}

  /deep/ .el-carousel__container {
    height: 274px;
  }
}


#contain {
  .el-header {
    margin: 30px auto 0;
    width: 1600px;
    text-align: center;
    font-size: 17px;
  }

  .bigBox {
    display: flex;
    justify-content: end;
    align-items: center;
    width: 1600px;
    height: 30px;
    margin: 30px auto;
    padding: 0px 0px 0px 20px;
  }
}



// 摄影师盒子1
.box1 {
  margin-top: 50px;
  margin-bottom: 30px;
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: space-between;


  .item {
    border-radius: 8px;
    background-color: #e8e8e8;
    height: 100%;
    width: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      background-color: #222222;
    }

    &:hover p {
      color: #929292;

    }



    .img {
      position: relative;
      width: 140px;
      height: 140px;
      border-radius: 50%;
      // border: 1px solid #A3983C;
      box-sizing: border-box;

      img {
        border-radius: 50%;
        width: 100%;
        height: 100%;
      }

      .eye {
        visibility: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, .5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: all .1s;

        #img {
          width: 50px !important;
          height: 38px !important;
          transition: all .2s;
        }

        p {
          margin-top: 20px;
          font-size: 12px;
          color: #D1D1D1;
        }
      }

      .mask1 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 160px;
        height: 160px;
        border: 1px solid rgba(199, 203, 83, 0.6);
        border-radius: 50%;
      }

      .mask2 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 180px;
        height: 180px;
        border: 1px solid rgba(199, 203, 83, 0.4);
        border-radius: 50%;
      }

      .mask3 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 200px;
        height: 200px;
        border: 1px solid rgba(199, 203, 83, 0.2);
        ;
        border-radius: 50%;
      }
    }

    h5 {
      font-weight: normal;
      color: #A3983C;
      font-size: 21px;
      margin-top: 32px;
    }

    p {
      text-align: center;
      padding: 0 30px;
      font-size: 13px;
      font-weight: normal;
      color: #646464;

      span {
        font-size: 20px;
      }
    }
  }
}

// 眼睛
.box1 .item:hover .eye {
  visibility: visible;
  // transform: rotate3d(1, 1, 1, 360deg);
}

.box1 .item:hover .eye #img {
  transform: rotate3d(1, 0, 0, 190deg);
}


// 摄影师盒子2
.box2 {
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .item {
    width: 300px;
    height: 80px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    &:hover {
      border-radius: 8px;
      -webkit-box-shadow: 0 3px 6px rgba(34, 33, 33, 0.2);

    }

    .img {
      width: 60px;
      height: 60px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      display: flex;
      flex-direction: column;
      justify-content: end;
      padding-left: 15px;
      height: 60px;
      font-size: 12px;
      color: #737373;

      .name {
        font-size: 20px;
        color: #000;
      }

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 200px;
      }
    }
  }
}

// 优秀供稿人
.goodBox {
  margin-top: 30px;
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;

  .item {
    margin-right: 15px;
    border-radius: 5px;
    height: 320px;
    width: 308px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:nth-child(5n) {
      margin-right: 0;
    }

    .img {
      border-radius: 5px;
      width: 100%;
      height: 232px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all .3s;

        &:hover {
          transform: scale(1.13);
        }
      }
    }

    .bottom {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .img {
        width: 36px;
        height: 36px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        flex: 1;
        padding-left: 10px;

        p {
          color: #838383;
        }
      }

    }
  }
}


.bton {
  width: 250px;
  height: 70px;
  border-radius: 30px;
  color: #7c7c7c;
  margin: 18px 40px 8px 25px;
}

.bttn {
  width: 220px;
  height: 70px;
  border-radius: 30px;
  color: #7c7c7c;
  margin: 18px 40px 8px 25px;
}

.xx_content {
  float: right;
  width: 180px;
  height: 70px;
}

.rect-img-wrap {
  width: 232px;
  height: 232px;
  margin: 0 18px 20px 0;
  object-fit: cover;
}

.rect-img-wrap>img {
  // width: 100%;
  // height: 100%;
  object-fit: cover;
}

.btns {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 432px;
  margin: 40px auto;
  padding: 36px 0px 0px 0px;
}


.btn {
  z-index: 3;
  width: 300px;
  height: 60px;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  background-color: #e34646;
  border: none;
}

.describe {
  z-index: 3;
  font-size: 32px;
  font-weight: 400;
}

.describ {
  z-index: 3;
  font-weight: 100;
  font-size: 20px;
}

.describes {
  position: absolute;
  z-index: 3;
  text-align: center;

  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  margin: 0 auto;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}

.demand {
  position: absolute;
  z-index: 3;
  width: 800px;
  height: 140px;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  //   background-color: #e34646;

  margin: 0 auto;
  left: 50%;
  bottom: -20%;
  transform: translate(-50%, -50%);
}

.contri-div {
  width: 800px;
  height: 150px;
  display: -webkit-flex;
  /* Safari */
  -webkit-justify-content: space-around;
  /* Safari 6.1+ */
  display: flex;
  justify-content: space-around;
  text-align: center;
}

.contri-img {
  width: 200px;

  .imgW {
    width: 60px;
    height: 60px;
  }
}

.demonstration {
  width: 100%;
  font-size: 20px;
  text-align: center;
}

#lbtImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 以下代码实现背景动画效果 */
  animation: loading 1.4s ease infinite;
  -webkit-animation: loading 1.4s ease infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
  background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-size: 400% 100%;
}

@-webkit-keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}

@keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}
</style>



// WEBPACK FOOTER //
// src/views/photographer.vue